<template>
<div class="page-wrapper">
	<div class="page page-member-creator">
		<div class="container">
			<div class="page-header">
				<router-link
					to="/members"
					class="page-back btn btn-plain flex-center p-0">
					<i class="material-icons">chevron_left</i>
					<span>{{ $t('Back to List') }}</span>
				</router-link>
				<h1 class="page-title" v-if="!id">{{ $t('Add New Member') }}</h1>
				<h1 class="page-title" v-if="id">
					<span>{{ $t('Edit Member') }}</span>
					<template v-if="id && name">
						<span class="mx-2">-</span>
						<span>{{ name }}</span>
					</template>
				</h1>
			</div>
			<div class="page-content">
				<form class="form" v-on:submit.prevent="submit">
					<div class="card-group mb-3">
						<!-- Left -->
						<div class="card col-lg-4 col-md-12 p-0">
							<div class="card-body box--md">
								<h5 class="mb-4">Member Profile</h5>
								<!-- Name -->
								<div class="form-group">
									<label><b>{{ $t('Name') }}</b></label>
									<input type="text" name="member_name" class="input form-control" autocomplete="nope" maxlength="50" v-model="name" required>
								</div>
								<!-- Email -->
								<div class="form-group">
									<label><b>{{ $t('Email') }}</b></label>
									<input type="email" name="member_email" class="input form-control" v-model="email" autocomplete="nope" required>
								</div>
								<!-- Password -->
								<div class="form-group">
									<label><b>{{ $t('Password') }}</b></label>
									<input type="password" name="member_password" class="input form-control" :class="{ 'error': isPasswordError }" minlength="6" v-model="password" autocomplete="new-password" :required="!id">
									<small class="text-danger" v-if="isPasswordError">Minimum 6 characters</small>
								</div>
								<!-- Phone -->
								<div class="form-group">
									<label><b>{{ $t('Phone Number') }}</b></label>
									<input type="tel" name="phone" class="input form-control" :class="{ 'error': isPhoneError }" v-model="phone" autocomplete="nope" placeholder="+62xxx" :required="role && role.value === 'cs'">
									<small class="text-danger" v-if="isPhoneError">Must be a valid phone number, with country code prefix</small>
								</div>
								<!-- Role -->
								<div class="form-group">
									<label><b>{{ $t('Role') }}</b></label>
									<multiselect
										label="label"
										track-by="value"
										v-model="role"
										:options="roles"
										:preselect-first="true"
										:show-labels="false"
										:allow-empty="false"
										@select="onRoleSelect">
									</multiselect>
								</div>
								<!-- Assign to All Product -->
								<!-- <div class="row">
									<div class="col-lg-9">
										<label><b>{{ $t('Assign To All Products') }}</b></label>
									</div>
									<div class="col-lg-3">
										<div class="form-group">
											<label class="input-checkbox-container text-left">
												<input
													type="checkbox"
													v-model="assignToAllProduct"
													class="toggle">
												<div class="toggle-btn d-inline-block"></div>
												<span></span>
											</label>
										</div>
									</div>
								</div> -->
								<div>
									<label><b>{{ $t('Other Settings') }}</b></label>
								</div>
								<div>
									<label>
										<input type="checkbox" class="input-checkbox input-checkbox-large" v-model="assignToAllProduct">
										<span></span>
										<span class="input-checkbox-text">Assign To All Products</span>
									</label>
								</div>
							</div>
						</div>
						<!-- Right -->
						<div class="card bg-grey col-lg-8 col-md-12 p-0">
							<div class="card-body box--md">
								<h5 class="mb-4">{{ $t('Permissions') }}</h5>
								<div class="capabilities">
									<!-- Dashboard -->
									<div class="capability">
										<div class="capability-entity"><b>{{ $t('Dashboard') }}</b></div>
										<div class="capability-options">
											<div class="row">
												<div class="col-md-4">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'dashboard_view'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">View Dashboard</span>
													</label>
												</div>
											</div>
										</div>
									</div>
									<!-- Products -->
									<div class="capability">
										<div class="capability-entity"><b>Product</b></div>
										<div class="capability-options">
											<div class="row">
												<div class="col-lg-3 col-md-6">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'product_add'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Create Product</span>
													</label>
												</div>
												<div class="col-lg-3 col-md-6">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'product_view'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">View Product</span>
													</label>
												</div>
												<div class="col-lg-3 col-md-6">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'product_edit'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Edit Product</span>
													</label>
												</div>
												<div class="col-lg-3 col-md-6">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'product_delete'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Delete Product</span>
													</label>
												</div>
											</div>
										</div>
									</div>
									<!-- Orders -->
									<div class="capability">
										<div class="capability-entity"><b>Orders</b></div>
										<div class="capability-options">
											<div class="row">
												<!-- View Order -->
												<div class="col-lg-3">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'order_view'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">View Orders</span>
													</label>
												</div>
												<!-- Process Order -->
												<div class="col-lg-3">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'order_process'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Process Orders</span>
													</label>
												</div>
												<!-- Shipping Label -->
												<div class="col-lg-3">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'order_shipping_label'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Print Shipping Labels</span>
													</label>
												</div>
												<!-- Export -->
												<div class="col-lg-3">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'order_export'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Export Data</span>
													</label>
												</div>
												<div class="well col-lg-12">
													<div class="row">
														<!-- Scoreboard Total Order -->
														<div class="col-lg-6">
															<label>
																<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'statistic_submission_count'" v-model="capabilities">
																<span></span>
																<span class="input-checkbox-text">Scoreboard Total Order</span>
															</label>
														</div>
														<!-- Scoreboard Order Pending -->
														<div class="col-lg-6">
															<label>
																<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'statistic_shipping_pending'" v-model="capabilities">
																<span></span>
																<span class="input-checkbox-text">Scoreboard Order Pending</span>
															</label>
														</div>
														<!-- Scoreboard Order Processed -->
														<div class="col-lg-6">
															<label>
																<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'statistic_shipping_processed'" v-model="capabilities">
																<span></span>
																<span class="input-checkbox-text">Scoreboard Order Processed</span>
															</label>
														</div>
														<!-- Scoreboard Order On Delivery -->
														<div class="col-lg-6">
															<label>
																<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'statistic_shipping_delivery'" v-model="capabilities">
																<span></span>
																<span class="input-checkbox-text">Scoreboard Order On Delivery</span>
															</label>
														</div>
														<!-- Scoreboard Order Complete -->
														<div class="col-lg-3">
															<label>
																<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'statistic_shipping_completed'" v-model="capabilities">
																<span></span>
																<span class="input-checkbox-text">Scoreboard Order Complete</span>
															</label>
														</div>
													</div>
												</div>
												<!-- Delete Order -->
												<!-- <div class="col-lg-6">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'order_delete'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Delete Order</span>
													</label>
												</div> -->
											</div>
										</div>
									</div>
									<!-- Statistics -->
									<!-- <div class="capability">
										<div class="capability-entity"><b>Statistics</b></div>
										<div class="capability-options">
											<div class="row">
												<div
													class="col-lg-3 col-md-4"
													v-for="(cap, index) in capabilitiesStats" :key="index">
													<label>
														<input
															type="checkbox"
															class="input-checkbox input-checkbox-large"
															:value="cap.key"
															v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">View {{ cap.label }}</span>
													</label>
												</div>
											</div>
										</div>
									</div> -->
									<!-- Wallet / Credits -->
									<div class="capability">
										<div class="capability-entity">
											<b>Credits</b>
										</div>
										<div class="capability-options">
											<div class="row">
												<!-- View Credits -->
												<div class="col-md-3">
													<label>
														<input
															type="checkbox"
															class="input-checkbox input-checkbox-large"
															:value="'wallet_view'"
															v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">View Credits</span>
													</label>
												</div>
												<!-- Withdraw Credits -->
												<div class="col-md-3">
													<label>
														<input
															type="checkbox"
															class="input-checkbox input-checkbox-large"
															:value="'wallet_withdraw'"
															v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Withdraw Credits</span>
													</label>
												</div>
											</div>
										</div>
									</div>
									<!-- Inventory -->
									<div class="capability">
										<div class="capability-entity">
											<b>Inventory</b>
										</div>
										<div class="capability-options">
											<div class="row">
												<!-- View Inventory -->
												<div class="col-md-3">
													<label>
														<input
															type="checkbox"
															class="input-checkbox input-checkbox-large"
															:value="'inventory_view'"
															v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">View Inventory</span>
													</label>
												</div>
												<!-- Update Stock Product -->
												<div class="col-md-3">
													<label>
														<input
															type="checkbox"
															class="input-checkbox input-checkbox-large"
															:value="'inventory_update_stock'"
															v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Update Stock Product</span>
													</label>
												</div>
											</div>
										</div>
									</div>
									<!-- Wholesale Order -->
									<div class="capability">
										<div class="capability-entity"><b>Monitoring Wholesale Order</b></div>
										<div class="capability-options">
											<div class="row">
												<!-- View Order -->
												<div class="col-lg-3">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'wholesale_view_order'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">View Wholesale Orders</span>
													</label>
												</div>
												<!-- List Order -->
												<div class="col-lg-3">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'wholesale_list_order'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">List Wholesale Order</span>
													</label>
												</div>
												<!-- Input Recipt Number -->
												<div class="col-lg-3">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'wholesale_mark_as_delivery'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Mark as Delivery</span>
													</label>
												</div>
												<!-- Input Recipt Number -->
												<div class="col-lg-3">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'wholesale_input_receipt_number'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Input Receipt Number</span>
													</label>
												</div>
												<div class="well col-lg-12">
													<div class="row">
														<!-- Scoreboard Total Order -->
														<div class="col-lg-6">
															<label>
																<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'wholesale_scoreboard_total_order'" v-model="capabilities">
																<span></span>
																<span class="input-checkbox-text">Scoreboard Total Order</span>
															</label>
														</div>
														<!-- Scoreboard Pending -->
														<div class="col-lg-6">
															<label>
																<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'wholesale_scoreboard_pending'" v-model="capabilities">
																<span></span>
																<span class="input-checkbox-text">Scoreboard Pending</span>
															</label>
														</div>
														<!-- Scoreboard Processing -->
														<div class="col-lg-6">
															<label>
																<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'wholesale_scoreboard_processing'" v-model="capabilities">
																<span></span>
																<span class="input-checkbox-text">Scoreboard Processing</span>
															</label>
														</div>
														<!-- Scoreboard Delivery -->
														<div class="col-lg-6">
															<label>
																<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'wholesale_scoreboard_delivery'" v-model="capabilities">
																<span></span>
																<span class="input-checkbox-text">Scoreboard Delivery</span>
															</label>
														</div>
														<!-- Scoreboard Delivered -->
														<div class="col-lg-6">
															<label>
																<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'wholesale_scoreboard_delivered'" v-model="capabilities">
																<span></span>
																<span class="input-checkbox-text">Scoreboard Delivered</span>
															</label>
														</div>
														<!-- Scoreboard Total Quantity & Delivered -->
														<div class="col-lg-6">
															<label>
																<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'wholesale_scoreboard_total_quantity_and_delivered'" v-model="capabilities">
																<span></span>
																<span class="input-checkbox-text">Scoreboard Total Quantity & Delivered</span>
															</label>
														</div>
													</div>
												</div>
												<!-- Delete Order -->
												<!-- <div class="col-lg-6">
													<label>
														<input type="checkbox" class="input-checkbox input-checkbox-large" :value="'order_delete'" v-model="capabilities">
														<span></span>
														<span class="input-checkbox-text">Delete Order</span>
													</label>
												</div> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="text-right mb-3">
						<button
							type="submit"
							class="btn btn-primary btn-lg"
							:class="{ 'is-loading': isSubmitting }"
							:disabled="isPasswordError || isPhoneError">
							Save
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
	<notifications group="createMember" position="bottom right" />
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
	memberRoles,
	capabilities,
	capabilitiesStats,
} from '@/lib/statics';
import teamApi from '@/api/team';
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'MemberCreator',
	props: {
		id: {
			type: String,
		},
	},
	data() {
		return {
			memberData: null,
			name: '',
			email: '',
			password: '',
			phone: '',
			role: null,
			roles: memberRoles,
			capabilities: [],
			capabilitiesStats,
			orderUpdatePaymentChecked: false,
			isSubmitting: false,
			isFetching: false,
			assignToAllProduct: false,
		};
	},
	methods: {
		...mapActions({
		}),
		onRoleSelect(role) {
			const defaultCaps = capabilities[role.value];
			this.capabilities = defaultCaps;
		},
		removeCapability(capability) {
			const index = this.capabilities.indexOf(capability);
			if (index !== -1) {
				this.capabilities.splice(index, 1);
			}
		},
		submit() {
			const capabilitiesJSON = JSON.stringify(this.capabilities);
			const member = {};
			member.name = this.name;
			member.email = this.email;
			member.password = this.password;
			member.phone = this.phone;
			member.role = this.role.value;
			member.capabilities = capabilitiesJSON;
			member.assign_to_all_product = this.assignToAllProduct;

			const callback = () => {
				const message = this.id ? 'Member Updated' : 'Member Created';
				this.$notify({
					group: 'createMember',
					title: 'Member',
					text: message,
					type: 'success',
				});
				this.$router.push({ name: 'members' });
			};
			const errorCallback = (e) => {
				const response = e.response.data;
				const errorMessage = response.message;
				this.$notify({
					group: 'createMember',
					title: 'Member',
					text: errorMessage,
					type: 'error',
				});
			};

			if (!this.id) {
				teamApi.createMember(member, callback, errorCallback);
			} else {
				teamApi.update(this.id, member, callback, errorCallback);
			}
		},
		fetchMemberDetails() {
			this.isFetching = true;
			const callback = (response) => {
				const member = response.data;
				this.memberData = duplicateVar(member);
				const role = this.roles.find(role => role.value === member.role);
				this.name = member.name;
				this.email = member.email;
				this.password = '';
				this.phone = member.phone ? member.phone : '';
				this.role = role;
				this.capabilities = member.capabilities;
				this.isFetching = false;
				this.assignToAllProduct = response?.data?.settings?.assign_to_all_product ?? false;
				this.initData();
			};
			const errorCallback = () => {
				this.isFetching = false;
			};
			teamApi.getDetails(this.id, callback, errorCallback);
		},
		checkCapabilities() {
			if (!this.isOwner && !this.isUserCan('team_member_add') && !this.isUserCan('team_member_edit')) {
				this.$router.push('/');
			}
		},
		initData() {
			const capabilities = this.capabilities;
			this.orderUpdatePaymentChecked = capabilities.includes('order_update_paid')
				|| capabilities.includes('order_update_unpaid');
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			isUserCan: 'isUserCan',
			isHasFeature: 'isHasFeature',
		}),
		isUpdateOrderEnabled() {
			return this.capabilities.indexOf('order_update') !== -1;
		},
		isEditOrderEnabled() {
			return this.capabilities.indexOf('order_edit') !== -1;
		},
		isOwner() {
			return this.user && this.user.role === 'owner';
		},
		isPasswordError() {
			return this.password.trim() !== '' && this.password.trim().length < 6;
		},
		isPhoneError() {
			return this.phone.trim() !== '' && !new RegExp(/^\+\d+$/).test(this.phone.trim());
		},
	},
	created() {
		if (this.id) {
			// Fetch Member Details
			this.fetchMemberDetails();
		}
		if (this.user) {
			this.checkCapabilities();
		}
	},
	watch: {
		user() {
			this.checkCapabilities();
		},
	},
};
</script>
